// Компактный рабочий стиль (выбор пользователя 25.09.2026): максимум данных на экране,
// плотные таблицы, мелкие отступы, минимум декора. ТСД сохраняет крупные элементы (.tsd в styles.css).
import { createTheme, rem } from '@mantine/core';

export const theme = createTheme({
  primaryColor: 'brand',
  primaryShade: { light: 6, dark: 5 },
  defaultRadius: 'md',
  // 10-12px по разделу 6 задания на редизайн (md/lg вместо стандартных 8/16)
  radius: { xs: rem(3), sm: rem(4), md: rem(6), lg: rem(8) },
  spacing: { xs: rem(6), sm: rem(8), md: rem(12), lg: rem(16), xl: rem(24) },
  fontSizes: { xs: rem(11.5), sm: rem(13), md: rem(14), lg: rem(16), xl: rem(18) },
  lineHeights: { xs: '1.35', sm: '1.4', md: '1.45', lg: '1.5', xl: '1.5' },
  fontFamily: '"Inter", system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif',
  fontFamilyMonospace: '"JetBrains Mono", ui-monospace, "Cascadia Mono", Consolas, monospace',
  headings: { fontWeight: '650', sizes: { h1: { fontSize: rem(22) }, h2: { fontSize: rem(18) }, h3: { fontSize: rem(15) }, h4: { fontSize: rem(14) } } },
  colors: {
    brand: ['#eef4ff', '#dce6fb', '#b6cbf5', '#8daeef', '#6b94ea', '#5584e7', '#487ce6', '#3a6acd', '#3160b7', '#2453a2'],
  },
  components: {
    Button: { defaultProps: { fw: 600 } },
    Badge: { defaultProps: { radius: 'sm' } },
    Paper: { defaultProps: { radius: 'md' } },
    Modal: { defaultProps: { radius: 'md', overlayProps: { blur: 2, backgroundOpacity: 0.45 } } },
    Drawer: { defaultProps: { overlayProps: { blur: 2, backgroundOpacity: 0.45 } } },
    Tooltip: { defaultProps: { withArrow: true } },
    Table: { defaultProps: { verticalSpacing: 4, horizontalSpacing: 8, fz: 'sm' } },
    Card: { defaultProps: { padding: 'sm' } },
    Tabs: { defaultProps: { variant: 'outline' } },
  },
});
